import {
  ColumnTypeEnum,
  OperationModel,
  OperatorEnum,
  OperatorTypeEnum,
  OperatorValueTypeEnum,
} from '@y42/json-schema';

export function createOperationModel(
  type: ColumnTypeEnum | null,
  operator?: OperatorEnum,
  values?: unknown[],
  operator_type?: OperatorTypeEnum,
  value_type?: OperatorValueTypeEnum,
): OperationModel {
  if (type) {
    return {
      operator: getOperatorBasedOnType(type),
      value_type: OperatorValueTypeEnum.None,
      operator_type: OperatorTypeEnum.Absolute,
      values: [],
    };
  }
  return {
    operator,
    value_type,
    operator_type,
    values: (values as OperationModel['values']) || [],
  };
}

function getOperatorBasedOnType(type: ColumnTypeEnum | null) {
  switch (type) {
    case ColumnTypeEnum.Numeric:
      return OperatorEnum.Equals;
    case ColumnTypeEnum.String:
      return OperatorEnum.Equals;
    case ColumnTypeEnum.Date:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Datetime:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Timestamp:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Boolean:
      return OperatorEnum.Equals;
    default:
      return OperatorEnum.Equals;
  }
}
